import { useTranslation } from "react-i18next";
import { useState } from "react";
import emailjs from "@emailjs/browser";
import ServicesBgImg from "../assets/services-bg-img.jpg";

function Contact() {
  const { t: translate } = useTranslation();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState(false);

  const handleChange = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setSending(true);
    setError(false);

    const templateParams = {
      name: formData.name,
      user_name: formData.name,
      email: formData.email,
      user_email: formData.email,
      phone: formData.phone,
      message: formData.message,
    };

    emailjs
      .send("service_zhtz31e", "template_f3kdeey", templateParams, "y9EbGYMVnU0P_s63i")
      .then(() => {
        setSubmitted(true);
        setSending(false);
        setFormData({ name: "", email: "", phone: "", message: "" });
      })
      .catch(() => {
        setError(true);
        setSending(false);
      });
  };

  return (
    <main
      className="contact-page"
      style={{ backgroundImage: `url(${ServicesBgImg})` }}
    >
      <div className="row contact-page__row">
        <div className="contact-page__info">
          <h1 className="section__title">{translate("contact.title")}</h1>
          <div className="section__divider"></div>

          <div className="contact-page__details">

            <div className="contact-detail">
              <span className="contact-detail__icon">✉️</span>
              <div>
                <h4 className="contact-detail__label">
                  {translate("contact.info.email")}
                </h4>
                <p className="contact-detail__value">
                  {translate("contact.info.emailValue")}
                </p>
              </div>
            </div>
            <div className="contact-detail">
              <span className="contact-detail__icon">📞</span>
              <div>
                <h4 className="contact-detail__label">
                  {translate("contact.info.phone")}
                </h4>
                <p className="contact-detail__value">
                  {translate("contact.info.phoneValue")}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="contact-page__form-wrapper">
          {submitted ? (
            <div className="contact-page__success">
              <span className="contact-page__success-icon">✓</span>
              <p>
                {translate("contact.form.success")}
              </p>
            </div>
          ) : (
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">{translate("contact.form.name")}</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder={translate("contact.form.name")}
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">{translate("contact.form.email")}</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder={translate("contact.form.email")}
                />
              </div>
              <div className="form-group">
                <label htmlFor="phone">{translate("contact.form.phone")}</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder={translate("contact.form.phone")}
                />
              </div>
              <div className="form-group">
                <label htmlFor="message">{translate("contact.form.message")}</label>
                <textarea
                  id="message"
                  name="message"
                  rows="5"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  placeholder={translate("contact.form.message")}
                ></textarea>
              </div>
              <button
                type="submit"
                className="btn btn--primary btn--full"
                disabled={sending}
              >
                {sending ? "Sending..." : translate("contact.form.submit")}
              </button>
              {error && (
                <p className="contact-form__error">
                  Something went wrong. Please try again.
                </p>
              )}
            </form>
          )}
        </div>
      </div>
    </main>
  );
}

export default Contact;
